jQuery(function($) {

    passport.configure({url: ultra_settings.endpoints.passport_url});

    $(document).on('rebuild', function () {
        // Grab the Passport JSON
        var passportInfoAJAX = passport.info();

        // Add login status HTML
        passportInfoAJAX.done(function (data, textStatus, jqXHR) {
            $(document).trigger('logged-in', [data]);

        });
        passportInfoAJAX.fail(function (jqXHR, textStatus, error) {
            if (jqXHR.status == 401) {
                $(document).trigger('logged-out');
            } else {
                $(document).trigger('logged-error');
                log('error');
                $(document).trigger('maintenance');
                log('Ultra Passport Maintenance Mode');
            }

            $(document).trigger('guestview');

        });

        if (loadEvents) {
            // Grab the events JSON
            var eventsAJAX = getEventJSON();
            $(document).trigger('rebuild-page', [eventsAJAX, passportInfoAJAX]);
        }

    });

    // Unit Tests
    if (!! _ut.length) {
        unitTests();
    }

    if (!! _newpoints.length) {
        //combineDates();
        $(document).on('logged-in', function(event,passport){
            newPoints(passport);
        });
    }
    if (!! _signup.length) {
        //combineDates();
        validate();
        createPost();
        fillParams();
        autofill();
    }

    if (!! _login.length) {
        validate();
        loginPost(passport);
        completeForms(passport);
    }

    if (!! _lost.length) {
        validate();
        lostPost();
    }
    if (!! _betaform.length) {
        betaSignup(passport);
    }

    if (!! _reset.length) {
        fillParams();
        resetPost();
    }

    if (!! _verify.length) {
        validate();
        fillParams();
        postProcessVerify();
        _verify.trigger('submit');
    }

    if (!! _changeemail.length) {
        fillParams();
        processChangeEmailForm(passport);
        _changeemail.trigger('submit');
    }

    if (!! _allevents.length) {
        loadEvents = true;
        $('body').append(registrationModal);
        $('body').append(updatesModal);
        modalClose('#updates-guest');
        loadRegistrationPage('#all-events', '#registration-confirm', '.events-nav');
    }

    if (!! _subscriptions.length) {
        loadEvents = true;
        $('body').append(updatesModal);
        loadSubscriptionPage('#subscriptions', '#updates-guest');
        modalClose('#updates-guest');
        $(document).on('logged-in', function(event,passport){
            registrationNotice(passport);
        });
    }

    if (!! _dashboard.length) {
        $(document).on('logged-in', function(event,passport){
            dashboard(passport);
            registrationNotice(passport);
        });
    }

    if (!! _edit.length) {
        $(document).on('logged-in', function(event,passport){
            //combineDates();
            completeForms(passport);
            updatePost(passport);
            editLoad(passport);
            homeeventChangeForm(passport);
            accountDeleteForm(passport);
            _edit.change(function(e) {
                _edit.addClass('changed');
            });
        });
    }

    if (!! _ticketspage.length || !!$('.ppgs').length) {
        $('body').append(updatesModal);
        modalClose('#updates-guest');
        $('body').append(registrationModal);
        modalClose('#registration-confirm');
        $('body').append(waitlistModal);
        modalClose('#waitlist-confirm');
    }

    if( !!_ppprotect.length) {
        //$('.signupbtn').trigger('click');
    }

    if( !! $('#activate-form').length ) {
        activatePost();
        $(document).on('logged-in', function(event,passport){
            activateExists(passport);
        });
    }

    if( modallogin ) {
        accountmodals();
    }

    if( !! $('.ppgs').length ) {
        passportGlobalSubscribe();
        $(document).on('logged-in', function(event,passport){
            passportGlobalSubscribeFill(passport);
        });
    }

    // Start the Application
    $(document).trigger('rebuild');

    setTimeout(function(){

        if(window.location.hash == '#signup') {
            $(".signupm>a").trigger('click');
        }

    }, 500);

});

